import { AccordionItem } from '@studiometa/ui';

/**
 * FooterLinksDesktopAccordionItem class.
 */
export class CollapseItem extends AccordionItem {
  /**
   * Class config.
   * @type {object}
   */
  static config = {
    name: 'CollapseItem',
    refs: [...AccordionItem.config.refs, 'title'],
  };
}
